import styled, { css } from 'styled-components';
import { breakpointDown } from '/shared/styled/Breakpoints';

interface Props {
  $hasPadding?: boolean;
  $fullWidth?: boolean;
  $leftAlign?: boolean;
  $alignItemsStart?: boolean;
  $alignItemsEnd?: boolean;
  $isColumn?: boolean;
  $hasNoPadding?: boolean;
  $isAirOrRail?: boolean;
}

function hasPaddingStyle({ $hasPadding = false, $fullWidth = false }: Props) {
  function fullWidthStyle() {
    if ($fullWidth) {
      return css`
        padding: 0;
        align-self: stretch;

        > * {
          width: 100%;
        }
      `;
    }
  }
  if ($hasPadding) {
    return css`
      margin: 0 -0.5rem;

      ${fullWidthStyle}
      > * {
        padding: 0 0.5rem;
      }
    `;
  }
}

function leftAlignStyle({ $leftAlign = false }: Props) {
  if ($leftAlign) {
    return css`
      justify-content: flex-start;
    `;
  }
}

function alignItemsStartStyle({ $alignItemsStart = false }: Props) {
  if ($alignItemsStart) {
    return css`
      align-items: flex-start;
    `;
  }
}
function alignItemsEndStyle({ $alignItemsEnd = false }: Props) {
  if ($alignItemsEnd) {
    return css`
      align-items: flex-start;
    `;
  }
}
function isColumnStyle({ $isColumn = false }: Props) {
  if ($isColumn) {
    return css`
      flex-direction: column;
    `;
  }
}

function hasNoPaddingStyle({ $hasNoPadding = false }: Props) {
  if ($hasNoPadding) {
    return css`
      padding: 0 !important;
    `;
  }
}

function isAirOrRailStyle({ $isAirOrRail = false }: Props) {
  if ($isAirOrRail) {
    return css`
    width: 100%;
    justify-content: flex-start;
    
      >:first-child {
        margin: 0 0.75rem 0 0.5rem;
        min-width: 15rem;
        font-size: 1.25rem;
      }
    `;
  }
}

export default styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  ${leftAlignStyle}
  ${hasPaddingStyle}
  ${alignItemsStartStyle}
  ${alignItemsEndStyle}
  ${isColumnStyle}
  ${hasNoPaddingStyle}
  ${isAirOrRailStyle}

  ${breakpointDown('tablet')} {
    flex-direction: column;
  }
`;
